<div style="display: inline-flex; flex: 1">
  <div #innerWrapper style="width: 100%; height: 100%; overflow: auto">
    <ng-container *cdkPortal>
      <div id="popped_out_container"></div>
    </ng-container>
    <div id="popped_in_container" style="height: 100%">
      <div id="popout_content" style="width: 100%; height: 100%">
        <ng-content></ng-content>
        @if (isPoppedOut) {
          <button
            class="fullscreen_button black_gradient_background"
            style="position: absolute; z-index: 20; top: 0; right: 0; padding: 2px 4px"
            (click)="toggleExternalFullScreen()"
          >
            @if (isDocumentInFullScreenMode()) {
              <fa-icon [icon]="faCompress"></fa-icon>
            }
            @if (!isDocumentInFullScreenMode()) {
              <fa-icon [icon]="faExpand"></fa-icon>
            }
          </button>
        }
        <div class="custom-cdk-overlay-container"></div>
      </div>
    </div>
  </div>
</div>
